import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Appfeature() {
  return (
    <section className="app_feature p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>App Features</h2>
            <p>
              TeeMates is a one-of-a-kind social media mobile application – a
              feature-packed, dedicated space for global golfers with following
              interactive features:
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Appfeature;
